<template>
	<button
		v-bind="$attrs"
		:aria-label="$attrs['aria-label'] || $attrs.title"
		:type="submit ? 'submit' : 'button'"
		:class="[
			'custom-btn',
			variant ? `custom-btn--${variant}` : '',
			inverted ? 'custom-btn--inverted' : '',
			fullWidth ? 'w-full' : ''
		]"
		v-wave="ripple"
		v-on="$listeners"
	>
		<slot></slot>
	</button>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		submit: {required: false, type: Boolean, default: false},
		variant: {required: false, type: String, default: 'primary'},
		inverted: {required: false, type: Boolean, default: false},
		fullWidth: {required: false, type: Boolean, default: false},
		ripple: {required: false}
	},
}
</script>

<style scoped>
.custom-btn{
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	white-space: nowrap;
}
.custom-btn:disabled{
	cursor: not-allowed;
}

.custom-btn--primary{
	padding: 0.625rem 1rem;
	border-radius: 1rem;
	line-height: 1.5rem;
	height: 3rem;
	font-weight: 600;
}

.custom-btn--primary:not(.custom-btn--inverted){
	background-color: rgb(var(--twc-primary));
	color: rgb(var(--twc-gray-secondary));
}
.custom-btn--primary:not(.custom-btn--inverted):disabled{
	background-color: rgb(var(--twc-gray-disabled-background));
}
.custom-btn--primary.custom-btn--inverted{
	color: rgb(var(--twc-primary-darken));
	background-color: rgb(var(--twc-gray-secondary));
	border: 1px solid rgb(var(--twc-gray-neutral));
}
.custom-btn--primary.custom-btn--inverted:disabled{
	color: rgb(var(--twc-gray-disabled));
}
</style>
